import ForbiddenPage from "components/protected-route/forbidden";
import { useSharedState } from "state";

type ProtectedRouteProps = {
  accessPage: "documents" | "payments" | "budgets" | "admin";
  children: React.ReactNode;
};

export default function ProtectedRoute({ accessPage, children }: ProtectedRouteProps) {
  const { user } = useSharedState();

  return (
    <>
      {(accessPage === "documents" && user.result.document_approval_access) ||
      (accessPage === "payments" && user.result.payment_approval_access) ||
      (accessPage === "budgets" && user.result.budget_access) ||
      (accessPage === "admin" && user.result.role === "admin") ? (
        children
      ) : (
        <ForbiddenPage />
      )}
    </>
  );
}
